export function calculateSaleTotals(items, montoExtra) {
  const subtotal = items.reduce((sum, item) => sum + Number(item.precio || 0) * Number(item.cantidad || 0), 0);
  const baseComision = items.filter((item) => item.tipo === "SERVICIO").reduce((sum, item) => sum + Number(item.precio || 0) * Number(item.cantidad || 0), 0);
  const extra = Number(montoExtra || 0);
  return { subtotal, baseComision, total: subtotal + extra };
}
